/* eslint-disable */

export const TransformDate = (date?: string | null) => {
    if (!date || String(date).length === 0) {
        return "-";
    }

    const dateFormat = new Date(date);

    if (Number.isNaN(dateFormat.getTime())) {
        return "-";
    }

    const day = dateFormat.getDate();
    const month = dateFormat.getMonth();
    const year = dateFormat.getFullYear();

    return `${String(day).padStart(2, "0")}/${String(month + 1).padStart(
        2,
        "0"
    )}/${year}`;
};
